import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import "./section3.css";

import Trabalhista from "../../assets/images/trabalhista.png";
import Penal from "../../assets/images/penal.png";
import Previdenciario from "../../assets/images/previdenciario.png";
import Civel from "../../assets/images/civel.png";
import Empresarial from "../../assets/images/empresarial.png";
import Familia from "../../assets/images/familia.png";
import Mediacao from "../../assets/images/mediacao.png";
import Documentos from "../../assets/images/documentos.png";
import Contencioso from "../../assets/images/contencioso.png";
import Consultorias from "../../assets/images/consultorias.png";

function Section3() {
  const [selectedArea, setSelectedArea] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const areas = [
    {
      id: "trabalhista",
      title: "Direito Trabalhista",
      desc: "Assessoria preventiva para empresas e defesa dos direitos do trabalhador, atuando em rescisões, horas extras, verbas rescisórias e dissídios coletivos ou individuais.",
      img: Trabalhista,
    },
    {
      id: "penal",
      title: "Direito Penal",
      desc: "Atuação firme, sigilosa e técnica na defesa criminal em inquéritos policiais, processos judiciais, tribunal do júri e recursos em instâncias superiores.",
      img: Penal,
    },
    {
      id: "previdenciario",
      title: "Direito Previdenciário",
      desc: "Planejamento previdenciário personalizado, concessão e revisão de aposentadorias, auxílios, pensões por morte e recursos administrativos perante o INSS e a Justiça.",
      img: Previdenciario,
    },
    {
      id: "civel",
      title: "Direito Cível",
      desc: "Solução de conflitos contratuais, responsabilidade civil, indenizações por danos materiais e morais, cobranças, recuperação de créditos e demandas imobiliárias.",
      img: Civel,
    },
    {
      id: "empresarial",
      title: "Direito Empresarial",
      desc: "Consultoria jurídica para empresas, elaboração e revisão de contratos corporativos, governança, proteção patrimonial e prevenção de passivos jurídicos.",
      img: Empresarial,
    },
    {
      id: "familia",
      title: "Direito de Família e Sucessões",
      desc: "Atendimento empático e humano em divórcios, partilha de bens, regulamentação de guarda, pensão alimentícia, inventários e planejamento sucessório.",
      img: Familia,
    },
    {
      id: "mediacao",
      title: "Mediação de Conflitos",
      desc: "Resolução extrajudicial de controvérsias priorizando a negociação, conciliação e acordos equilibrados, reduzindo custos, desgaste emocional e tempo.",
      img: Mediacao,
    },
    {
      id: "documentos",
      title: "Elaboração de Documentos",
      desc: "Elaboração, análise e revisão criteriosa de contratos, estatutos sociais, acordos de sócios, termos de adesão e instrumentos jurídicos de alta complexidade.",
      img: Documentos,
    },
    {
      id: "contencioso",
      title: "Contencioso Judicial e Arbitral",
      desc: "Representação estratégica e de alta performance em litígios perante tribunais estaduais, federais, superiores e câmaras arbitrais.",
      img: Contencioso,
    },
    {
      id: "consultorias",
      title: "Consultoria Jurídica Preventiva",
      desc: "Orientação jurídica personalizada para tomadas de decisão seguras, mapeando riscos legais e criando estratégias para pessoas físicas e jurídicas.",
      img: Consultorias,
    },
  ];

  return (
    <section className="container-fluid mt-5 px-2 px-md-4 px-xl-5 section3">
      <div className="section3-wrapper">
        <div className="text-center mb-4">
          <h2 className="titulos-secoes" data-aos="fade-up">
            Áreas de Atuação
          </h2>
        </div>

        <div className="grid-areas-container rounded-3 p-3 p-md-4 shadow-lg">
          <div className="grid-areas">
            {areas.map((area, index) => (
              <div
                key={area.id}
                className="area-card-wrapper"
                data-aos="zoom-in"
                data-aos-delay={100 + (index % 4) * 50}
                onClick={() => setSelectedArea(area)}
              >
                <div className="card area-card-inner rounded-3 border-0 overflow-hidden">
                  <img
                    src={area.img}
                    className="card-img area-img"
                    alt={area.title}
                    loading="lazy"
                    width="300"
                    height="300"
                  />
                  <div className="card-img-overlay area-card-overlay d-flex flex-column justify-content-end p-3">
                    <h3 className="card-title text-white fs-5 fw-semibold m-0">
                      {area.title}
                    </h3>
                    <span className="text-dourado font-xs fw-semibold mt-1 d-inline-flex align-items-center gap-1">
                      Conhecer Área
                      <svg
                        width="14"
                        height="14"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal de Detalhes da Área de Atuação */}
      {selectedArea && (
        <div className="modal-backdrop-custom d-flex align-items-center justify-content-center p-3">
          <div className="modal-content-custom bg-white rounded-3 shadow-lg p-4 p-md-5 max-w-600 position-relative animate-pop">
            <button
              type="button"
              className="btn-close position-absolute top-0 end-0 m-3"
              aria-label="Fechar modal"
              onClick={() => setSelectedArea(null)}
            ></button>

            <div className="d-flex align-items-center gap-3 mb-3">
              <div className="modal-area-img-container rounded-2 overflow-hidden">
                <img
                  src={selectedArea.img}
                  alt={selectedArea.title}
                  width="70"
                  height="70"
                  className="object-cover"
                />
              </div>
              <div>
                <span className="badge badge-dourado mb-1">
                  Área de Atuação
                </span>
                <h3 className="fs-4 fw-bold text-dark m-0">
                  {selectedArea.title}
                </h3>
              </div>
            </div>

            <p className="text-secondary fs-6 line-height-relaxed my-3">
              {selectedArea.desc}
            </p>

            <div className="d-flex flex-wrap gap-2 mt-4 pt-2 border-top">
              <a
                href={`https://wa.me/5511954242066?text=Olá,%20gostaria%20de%20orientação%20sobre%20${encodeURIComponent(selectedArea.title)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn botao-dourado flex-grow-1"
              >
                Falar sobre esta área no WhatsApp
              </a>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setSelectedArea(null)}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Section3;
